module.exports = __webpack_public_path__ + "img/lg_ring_r_l_1_1@2x.10ee532c.png";